import { render, staticRenderFns } from "./ContributionsProgressBar.vue?vue&type=template&id=2d15432c&scoped=true"
import script from "./ContributionsProgressBar.vue?vue&type=script&lang=ts"
export * from "./ContributionsProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsProgressBar.vue?vue&type=style&index=0&id=2d15432c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d15432c",
  null
  
)

export default component.exports